import { Navigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth.js';

/**
 * RoleGuard — wraps a route and only renders children if the current role is
 * in the `allow` list. Otherwise redirects to /dashboard.
 *
 * Reads the role from useAuth(), which transparently resolves to either the
 * demo persona (RoleContext) or the JWT-decoded user (AuthContext).
 *
 * Usage:
 *   <RoleGuard allow={['team_leader']}><Settings /></RoleGuard>
 */
export default function RoleGuard({ allow = [], redirectTo = '/dashboard', children }) {
  const { user } = useAuth();

  if (allow.length > 0 && !allow.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
